import {SpreadsheetRecordFieldDto} from './SpreadsheetRecordFieldDto';

export class SpreadsheetRecordDto {
    constructor(public Value: string, public Fields: SpreadsheetRecordFieldDto[]) {
    }
}